import React from 'react';


class POIs extends React.Component
{
    constructor(props){
        super(props);
        
        this.state = {
            poiList: [],
            selectedList: [],
            showList: false,
        }
    }

    componentDidMount(){
        if(this.props.propId){
            this.getPOIs(this.props.propId);
        }
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.propId && nextProps.propId !== this.props.propId){
            this.getPOIs(nextProps.propId);
        }
    }

    getPOIs = (pid) => {
        if(pid) {
            var self = this;
            var url = window.sessionStorage.getItem("RootAPI") + `listings/${pid}/pois`;
                        
            fetch(url,
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + window.sessionStorage.getItem("APIKey")
                },
                method: "GET"
            })
            .then(response => {
                if (response.ok) return response.json()
                else throw Error(response.statusText)
            })
            .then(json => {
                if(json && json.Pois && json.Pois.length > 0){
                    self.setState({poiList: json.Pois, selectedList: [], showList: false});
                }
            })
            .catch(function (data) {
                console.log(data);
            });
        }
    }

    hangeChange = (event) => {
        var selectedList = this.state.selectedList;
        var sLst = [];
        if(event.target.checked) {
            if(!selectedList.includes(event.target.name)){
                selectedList.push(event.target.name);
            }
        }
        else{
            selectedList = selectedList.filter(i => i !== event.target.name);
        }
        sLst = this.state.poiList.filter(i => selectedList.includes(i.Type));
        
        if(this.props.poiChanged) this.props.poiChanged(sLst);
        
        this.setState({ selectedList });
    }
    
    render() {
        const {poiList, showList, selectedList} = this.state;

        var poiNames = [];
        poiList.map(i => {
            if(!poiNames.includes(i.Type)) poiNames.push(i.Type);
            return null;
        });

        var wrapperStyle = {};
        var listStyle = {};
        if(showList) wrapperStyle.zIndex = 9999;
        if(this.props.top){
            wrapperStyle.top = this.props.top;
            listStyle.top = "-" + this.props.top;
        }
        if(this.props.height){
            listStyle.height = this.props.height;
        } 

        var listDiv = (
            <div className="poi_list" style={listStyle}>
                {poiNames.map((item,i) => { 
                    return (
                        <div key={i} className="poi_list_item">
                            <input type="checkbox" name={item} onChange={this.hangeChange} style={{marginRight: 5}} checked={selectedList.includes(item)} />
                            {item}
                        </div>)
                    })
                }
            </div>
        );

        

        return (
            <div>
            {(poiNames && poiNames.length > 0) ?
                <div className="poi_filter_wrapper" style={wrapperStyle}>
                    {showList && listDiv}
                    <div className="filter_button" onClick={() => this.setState({showList: !this.state.showList})} title="Point of Interest Filters">
                        <i className="fa fa-caret-down"></i>
                        {showList && <i className="fa fa-times filter_close_button"></i>}
                    </div>
                </div>
                : null                
            }
            </div>
        )
    }
}

export default POIs;